import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  CohortQuery,
  CohortStatus,
} from 'src/app/cohorts/services/cohort.service';
import { SelectableOption } from 'src/app/releases/release-query/release-query.component';

@Component({
  selector: 'dcc-cohort-query',
  templateUrl: './cohort-query.component.html',
  styleUrls: ['./cohort-query.component.scss'],
})
export class CohortQueryComponent implements OnInit {
  @Input() total: number;
  @Input() query: CohortQuery;

  @Output() updateQuery: EventEmitter<CohortQuery> =
    new EventEmitter<CohortQuery>();

  statusOptions: SelectableOption<CohortStatus>[] = [
    {
      name: CohortStatus.Disabled,
      value: CohortStatus.Disabled,
      selected: false,
    },
    {
      name: CohortStatus.AwaitingApproval,
      value: CohortStatus.AwaitingApproval,
      selected: true,
    },
    { name: CohortStatus.Enabled, value: CohortStatus.Enabled, selected: true },
  ];

  statusOptionsSelected: CohortStatus[];

  ngOnInit(): void {
    this.statusOptions = this.statusOptions.map((status) => {
      return {
        name: status.name,
        value: status.value,
        selected: this.query.status.includes(status.value),
      };
    });

    this.statusOptionsSelected = this.getSelectedItems(this.statusOptions);
  }

  onCohortNameEntered(item: string) {
    this.query.name = item;
    this.updateQuery.emit(this.buildCohortQuery());
  }

  onCohortOwnerEntered(item: string) {
    this.query.creator = item;
    this.updateQuery.emit(this.buildCohortQuery());
  }

  onStatusSelectionChange(selectedItems: SelectableOption<CohortStatus>[]) {
    this.statusOptions = this.onSelectionChanges(
      this.statusOptions,
      selectedItems,
    );
    this.query.status = this.getSelectedItems(this.statusOptions);
    this.updateQuery.emit(this.buildCohortQuery());
  }

  private onSelectionChanges(
    options: SelectableOption<CohortStatus>[],
    selected: SelectableOption<CohortStatus>[],
  ): SelectableOption<CohortStatus>[] {
    options.map((option) => {
      option.selected = selected.some(
        (selectedItem) =>
          (selectedItem.value ?? selectedItem.name) ===
          (option.value ?? option.name),
      );
    });
    return options;
  }

  private buildCohortQuery(): CohortQuery {
    return {
      name: this.query.name,
      creator: this.query.creator,
      status: this.statusOptions
        .filter((option) => option.selected)
        .map((option) => option.name),
    } as CohortQuery;
  }

  private getSelectedItems(
    selected: SelectableOption<CohortStatus>[],
  ): CohortStatus[] {
    return selected
      .filter((option) => option.selected)
      .map((option) => option.value);
  }
}
